import { ChevronUp, Table2 } from "lucide-react";

import { CountBadge } from "@/components/semantic-badges";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface FloatingPanelToggleProps {
  isOpen: boolean;
  onClick: () => void;
  tagCount: number;
  label?: string;
}

/** Floating button that reopens a viewer's bottom results panel; hidden while the panel is open. */
export function FloatingPanelToggle({
  isOpen,
  onClick,
  tagCount,
  label = "Tag Results",
}: FloatingPanelToggleProps) {
  return (
    <Button
      type="button"
      onClick={onClick}
      tabIndex={isOpen ? -1 : 0}
      aria-hidden={isOpen}
      className={cn(
        "fixed bottom-4 right-4 z-50 shadow-lg hover:shadow-xl",
        isOpen && "pointer-events-none translate-y-20 opacity-0"
      )}
    >
      <Table2 aria-hidden="true" />
      <span>{label}</span>
      {tagCount > 0 ? <CountBadge value={tagCount} tone="onPrimary" max={999} /> : null}
      <ChevronUp aria-hidden="true" />
    </Button>
  );
}
